document.addEventListener("DOMContentLoaded", () => {
  const informedRadios = document.querySelectorAll("#is_informed_rlt_true, #is_informed_rlt_false, #is_informed_rlt");

  // No markers in the markup for the 2nd/3rd RLT columns, so we locate them by position:
  // the "RLT informée" radios sit in the 1st of the 3 sibling columns of .three-columns.
  const columns = document.getElementById("is_informed_rlt_true")?.closest(".three-columns")?.children;
  const statusColumn = columns?.[1];
  const responseColumn = columns?.[2];

  if (informedRadios.length === 0 || !statusColumn || !responseColumn) return;

  const acceptedRadios = document.querySelectorAll('[id^="has_accepted_rlt_true_"]');

  const isInformed = () => document.getElementById("is_informed_rlt_true")?.checked ?? false;
  const isConflict = () => document.getElementById("has_accepted_rlt_true_conflict")?.checked ?? false;

  const updateRltColumns = () => {
    statusColumn.hidden = !isInformed();
    responseColumn.hidden = !(isInformed() && isConflict());
  };

  informedRadios.forEach((radio) => radio.addEventListener("change", updateRltColumns));
  acceptedRadios.forEach((radio) => radio.addEventListener("change", updateRltColumns));

  updateRltColumns();
});
